import { useProductSpecificationValues } from '../../ProductSpecificationValues/hooks/useProductSpecificationValues';
import { useProductSpecificationText } from './useProductSpecificationText';

const renderClass = (name, blockClass) => {
	return `${blockClass ? `${name}--${blockClass} vtex-product-specification-1-x-${name}--${blockClass}` : ''}`;
};

const renderFirstClass = (name, blockClass) => {
	return `${blockClass ? `${name}--${blockClass}--first vtex-product-specification-1-x-${name}--${blockClass}--first` : ''}`;
};

const PST = () => {
	const pstProps = useProductSpecificationText();
	const psvProps = useProductSpecificationValues();
	const props = pstProps || psvProps;

	if (!props) return null;
	return (
		<>
			{props.message === '{groupName}' && (
				<span
					data-selection={props?.componentId}
					className={`groupName vtex-product-specifications-1-x-groupName ${renderClass('groupName', props.blockClass)}`}
				>
					Geral
				</span>
			)}
			{props.message === '{specificationName}' && (
				<span
					data-selection={props?.componentId}
					className={`specificationName vtex-product-specifications-1-x-specificationName ${renderClass('specificationName', props.blockClass)}`}
				>
					{props.mzSpecificationText}
				</span>
			)}
			{props.message === '{specificationValue}' &&
				(Math.floor(Math.random() * 2) === 0 ? (
					<>
						<span
							data-selection={props?.componentId}
							className={`specificationValue specificationValue--first vtex-product-specifications-1-x-specificationValue vtex-product-specifications-1-x-specificationValue--first ${renderFirstClass('specificationValue', props.blockClass)} ${renderClass('specificationValue', props.blockClass)}`}
						>
							Ouro Amarelo 18k
						</span>
						<span
							className={`specificationValue vtex-product-specifications-1-x-specificationValue ${renderClass('specificationValue', props.blockClass)}`}
						>
							Ouro 18k
						</span>
						<span
							className={`specificationValue vtex-product-specifications-1-x-specificationValue ${renderClass('specificationValue', props.blockClass)}`}
						>
							Joias com diamantes
						</span>
						<span
							className={`specificationValue vtex-product-specifications-1-x-specificationValue ${renderClass('specificationValue', props.blockClass)}`}
						>
							Joias com safira
						</span>
						<span
							className={`specificationValue vtex-product-specifications-1-x-specificationValue ${renderClass('specificationValue', props.blockClass)}`}
						>
							Joias com pedras orientais
						</span>
					</>
				) : (
					<span
						data-selection={props?.componentId}
						className={`specificationValue specificationValue--first vtex-product-specifications-1-x-specificationValue vtex-product-specifications-1-x-specificationValue--first ${renderFirstClass('specificationValue', props.blockClass)} ${renderClass('specificationValue', props.blockClass)}`}
					>
						Material: ouro 18k {'\n'}
						Acabamento: polido {'\n'}
						Tamanho: 6 mm de largura (topo){'\n'}
						{'\n'}
						Pedras: 3 safiras azul de 1 x 1 mm cada e 4 diamantes de 0,5 ponto cada
					</span>
				))}
		</>
	);
};

export default PST;
